<template>
  <div ref="messages" class="h-full overflow-y-auto p-4">
    <ul v-if="comments.length" class="space-y-8 text-sm mb-4">
      <template v-for="comment in comments">
        <CommentForm
          v-if="current && current.uuid === comment.uuid && isActionEdit"
          :key="comment.uuid"
          :comment="comment"
          :submit-action="updateComment"
        >
          <button type="button" class="btn btn-ghost ml-2" @click="cancelAction">Cancel</button>
        </CommentForm>
        <div
          v-else-if="current && current.uuid === comment.uuid && isActionDelete"
          :key="comment.uuid"
          class="bg-white p-4 rounded border"
        >
          <CommentDeleteForm :comment="comment" :submit-action="deleteComment">
            <template #default="commentDeleteFormProps">
              <button
                type="button"
                :disabled="commentDeleteFormProps.disabled"
                class="btn btn-ghost ml-2"
                @click="cancelAction"
              >
                Cancel
              </button>
            </template>
          </CommentDeleteForm>
        </div>
        <CommentLine
          v-else
          :key="comment.uuid"
          :comment="comment"
          @edit-comment="editComment"
          @delete-comment="confirmDeleteComment"
        />
      </template>
    </ul>
    <slot :scroll-to-end="scrollToEnd" />
  </div>
</template>

<script>
import CommentLine from './comments/CommentLine.vue';
import CommentForm from './CommentForm.vue';
import CommentDeleteForm from './CommentDeleteForm.vue';

const ACTION_EDIT = 'ACTION_EDIT';
const ACTION_DELETE = 'ACTION_DELETE';

export default {
  name: 'Comments',

  components: {
    CommentLine,
    CommentForm,
    CommentDeleteForm,
  },

  props: {
    comments: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      current: null,
      action: null,
    };
  },

  computed: {
    isActionEdit() {
      return this.action === ACTION_EDIT;
    },
    isActionDelete() {
      return this.action === ACTION_DELETE;
    },
  },

  mounted() {
    this.scrollToEnd();
  },

  methods: {
    displayComposer() {
      this.composerVisible = true;
      this.$nextTick(() => {
        this.scrollToEnd();
      });
    },
    editComment(comment) {
      this.action = ACTION_EDIT;
      this.current = JSON.parse(JSON.stringify(comment));
    },
    confirmDeleteComment(comment) {
      this.action = ACTION_DELETE;
      this.current = JSON.parse(JSON.stringify(comment));
    },
    async updateComment(comment) {
      try {
        await this.$store.dispatch({
          type: 'ui/comments/update',
          commentUuid: this.current.uuid,
          formData: comment,
        });

        this.cancelAction();
      } catch (error) {
        /** handle error */
      }
    },
    async deleteComment() {
      try {
        await this.$store.dispatch({
          type: 'ui/comments/destroy',
          commentUuid: this.current.uuid,
        });

        this.$emit('comment:deleted', JSON.parse(JSON.stringify(this.current)));

        this.cancelAction();
      } catch (error) {
        /** handle error */
      }
    },
    cancelAction() {
      this.current = null;
      this.action = null;
    },
    scrollToEnd() {
      this.$refs.messages.scrollTop = this.$refs.messages.scrollHeight;
    },
  },
};
</script>
